import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeleteContentsMutation } from "../graphql/mutations";
import type {
  DeleteContentsMutationType,
  DeleteContentsMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDeleteContentsMutation = (
  options?: MutationHookOptions<
    DeleteContentsMutationType,
    DeleteContentsMutationVariablesType
  >
) => {
  return useMutation<
    DeleteContentsMutationType,
    DeleteContentsMutationVariablesType
  >(DeleteContentsMutation, options);
};
